import { createTheme } from "@mui/material/styles";

const theme = createTheme({
  palette: {
    primary: {
      main: "#1f3a5f",
      contrastText: "#ffffff",
    },
    secondary: {
      main: "#3d7ea6",
      contrastText: "#ffffff",
    },
    background: {
      default: "#f4f6f8",
    },
  },
  shape: {
    borderRadius: 8,
  },
});

export default theme;
